import { call, put, takeLatest } from 'redux-saga/effects';
import { AppService, MarketplaceServices } from 'services';
import BaseAction from '../actions/baseAction';
import MarketplaceAction, {
  MarketplaceTypes,
} from '../actions/marketplaceAction';
import { byAlpha3 } from 'iso-country-codes';
import { SupportedCountry } from 'models';
import { CONFIG } from 'constants/index';
import { Theme } from '@mui/material';
import ProvisioningServices from 'services/provisioningServices';
import { getAllRequestTicket, getAllApprovalTicket } from 'services/ticketServices';

function mapCountriesName(countries: SupportedCountry[]) {
  return countries.map(country => ({
    ...country,
    name: byAlpha3[country.iso_alpha3]?.name || country.iso_alpha3,
  })).sort((a, b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1);
};

export function* getUser(action: any): any {
  try {
    const user = yield call(MarketplaceServices.getUser, action.email);
    yield put(MarketplaceAction.getUserSuccess(user));
  } catch (error) {
    yield put(
      BaseAction.errorHandling({
        message: `GET_USER ${error}`,
      }),
    );
  }
}
export function* getCategory(action: any): any {
  try {
    const res = yield call(MarketplaceServices.getListCatalog, action.params);
    yield put(MarketplaceAction.getCategorySuccess(res));
  } catch (error) {
    yield put(
      BaseAction.errorHandling({
        message: `GET_CATEGORY ${error}`,
      }),
    );
  }
}

export function* getUserAddress(action: any): any {
  try {
    const res = yield call(MarketplaceServices.getShippingAddressOfUser, action.id);
    yield put(MarketplaceAction.getUserAddressSuccess(res));
  } catch (error) {
    yield put(
      BaseAction.errorHandling({
        message: `GET_USER_ADDRESS ${error}`,
      }),
    );
  }
}

export function* getCartDetails(action: any): any {
  try {
    const res = yield call(MarketplaceServices.getCartDetails, action.id, action.locale);
    yield put(MarketplaceAction.getCartDetailsSuccess(res));
  } catch (error) {
    yield put(
      BaseAction.errorHandling({
        message: `GET_CART_DETAILS ${error}`,
      }),
    );
  }
}

export function* getSupportedCountries(action: any): any {
  try {
    const res = yield call(MarketplaceServices.getSupportedCountries, action.id);
    yield put(MarketplaceAction.getSupportedCountriesSuccess(mapCountriesName(res)));
  } catch (error) {
    yield put(
      BaseAction.errorHandling({
        message: `GET_SUPPORTED_COUNTRIES ${error}`,
      }),
    );
  }
}

export function* getMarketplaceTheme(): any {
  try {
    const res = yield call(AppService.getValueConfigAzure,CONFIG.MARKETPLACE_THEME.KEY, CONFIG.MARKETPLACE_THEME.LABEL);
    const parsedData: Partial<Theme> = res;
    yield put(MarketplaceAction.getMarketplaceThemeSuccess(parsedData));
  } catch (error) {
    yield put(
      BaseAction.errorHandling({
        message: `GET_MARKETPLACE_THEME ${error}`,
      }),
    );
  }
}
export function* getListSoftwareSubscription(action: any): any {
  try {
    const res = yield call(ProvisioningServices.getListSoftwareSubscription, action.email);    
    yield put(MarketplaceAction.getListSoftwareSubscriptionSuccess(res));
  } catch (error) {
    yield put(
      BaseAction.errorHandling({
        message: `GET_LIST_SOFTWARE_SUBSCRIPTION ${error}`,
      }),
    );
  }
}

export function* getAllMarketplaceRequestsOpen(action: any): any {
  try {
    const result = yield call(getAllRequestTicket, action.params);
    if (result.status === 200) {
      yield put(MarketplaceAction.getAllMarketplaceRequestsOpenSuccess(result.data));
    }
  } catch (error) {
    yield put(MarketplaceAction.getAllMarketplaceRequestsOpenFail());
    yield put(BaseAction.errorHandling({
      message: `GET_ALL_MARKETPLACE_REQUESTS_OPEN ${error}`
    }));
  }
}

export function* getAllMarketplaceRequestsClosed(action: any): any {
  try {
    const result = yield call(getAllRequestTicket, action.params);
    if (result.status === 200) {
      yield put(MarketplaceAction.getAllMarketplaceRequestsClosedSuccess(result.data));
    }
  } catch (error) {
    yield put(MarketplaceAction.getAllMarketplaceRequestsClosedFail());
    yield put(BaseAction.errorHandling({
      message: `GET_ALL_MARKETPLACE_REQUESTS_CLOSED ${error}`
    }));
  }
}

export function* getAllMarketplaceApprovalOpen(action: any): any {
  try {
    const result = yield call(getAllApprovalTicket, action.params);
    if (result.status === 200) {
      yield put(MarketplaceAction.getAllMarketplaceApprovalOpenSuccess(result.data));
    }
  } catch (error) {
    yield put(MarketplaceAction.getAllMarketplaceApprovalOpenFail());
    yield put(BaseAction.errorHandling({
      message: `GET_ALL_MARKETPLACE_APPROVAL_OPEN ${error}`
    }));
  }
}

export function* getAllMarketplaceApprovalClosed(action: any): any {
  try {
    const result = yield call(getAllApprovalTicket, action.params);
    if (result.status === 200) {
      yield put(MarketplaceAction.getAllMarketplaceApprovalClosedSuccess(result.data));
    }
  } catch (error) {
    yield put(MarketplaceAction.getAllMarketplaceApprovalClosedFail());
    yield put(BaseAction.errorHandling({
      message: `GET_ALL_MARKETPLACE_APPROVAL_CLOSED ${error}`
    }));
  }
}

export const watchMarketplace = [
  takeLatest(MarketplaceTypes.GET_USER, getUser),
  takeLatest(MarketplaceTypes.GET_USER_ADDRESS, getUserAddress),
  takeLatest(MarketplaceTypes.GET_CATEGORY, getCategory),
  takeLatest(MarketplaceTypes.GET_CART_DETAILS, getCartDetails),
  takeLatest(MarketplaceTypes.GET_SUPPORTED_COUNTRIES, getSupportedCountries),
  takeLatest(MarketplaceTypes.GET_MARKETPLACE_THEME, getMarketplaceTheme),
  takeLatest(MarketplaceTypes.GET_LIST_SOFTWARE_SUBSCRIPTION, getListSoftwareSubscription),
  takeLatest(MarketplaceTypes.GET_ALL_MARKETPLACE_REQUESTS_OPEN, getAllMarketplaceRequestsOpen),
  takeLatest(MarketplaceTypes.GET_ALL_MARKETPLACE_REQUESTS_CLOSED, getAllMarketplaceRequestsClosed),
  takeLatest(MarketplaceTypes.GET_ALL_MARKETPLACE_APPROVAL_OPEN, getAllMarketplaceApprovalOpen),
  takeLatest(MarketplaceTypes.GET_ALL_MARKETPLACE_APPROVAL_CLOSED, getAllMarketplaceApprovalClosed),
];
